import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('dependentManagement', 'update-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'providers',
  type: 'put',
  slug: [
    'care_role_relation',
    'assignments',
    {
      type: 'payload',
      selector: ['id'],
    },
    'status',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dependentManagement/assignment-update-req.js